var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEspresso(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#765638;stroke-linejoin:round;stroke-width:3px;}.cls-2{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.2,119.5c.41,2.64.85,5.32,1.3,8a12,12,0,0,0-8.15-1.88c-2.33.42-5.6,2-7.94,7.22a16.49,16.49,0,0,0,.9,15c4.1,7.37,13.68,13.45,22,14.18q1.32,5.82,2.69,11.41h43.2c1.88-7.68,3.7-15.68,5.4-24,2.12-10.37,3.9-20.39,5.4-30Zm-8.27,24.56a8.39,8.39,0,0,1-.62-7.92c1.32-2.93,2.66-3.18,3.09-3.26a3.81,3.81,0,0,1,.59,0c2.31,0,5.15,2.23,6.61,3.63l4,17.71C110.14,152.62,104.43,148.55,101.93,144.06Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 288,
    height: 288
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspresso);
export default __webpack_public_path__ + "static/media/espresso.ea1d8a801d7421f7ab90a45a5f0a65eb.svg";
export { ForwardRef as ReactComponent };